import { useContext} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import EmailContext from 'context/EmailContext';
import {convertDateToInputDate} from "helpers/HelpDate";


let myAbilities = HelpAbility();

function Item({setSelectedEmail, getVinculedClientsOfEmail, setModalVincularCliente, i, email: ema, deleteEmail }) {
    const { setEmail } = useContext(EmailContext);
    const { _id, documentClient, email, numeroReportes, primerReporte, ultimoReporte } = ema;

    const handleIsUpdateForm = () => {
        setEmail({
             ...ema,
             primerReporte: convertDateToInputDate(primerReporte),
             ultimoReporte: convertDateToInputDate(ultimoReporte)
            })
    }

    const handleDeleteEmail = async () => {
        deleteEmail({ id: _id })
    }

    const handleLinkClient = async () => {
        setModalVincularCliente(true);
        setSelectedEmail(ema);
        getVinculedClientsOfEmail({email: ema, numDocument: documentClient})
    }

    return (
        <>
            <tr>
                <th className="text-center" scope="row">{i + 1}</th>
                <td className="text-center">{email}</td>
                <td className="text-center">{numeroReportes}</td>
                <td className="text-center">{convertDateToInputDate(primerReporte)}</td>
                <td className="text-center">{convertDateToInputDate(ultimoReporte)}</td>
                <td className="text-center">{documentClient || "Sin Asignar"}</td>

                {myAbilities.hasAny([C.A.EMAIL.LINK, C.A.EMAIL.UPDATE, C.A.EMAIL.DELETE]) && <td className="text-center d-flex">
                    {myAbilities.has(C.A.EMAIL.LINK) &&

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Cliente</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-info me-2"
                                onClick={handleLinkClient}>
                                <i className="bi bi-person-fill" />
                            </button>
                        </OverlayTrigger>}

                    {myAbilities.has(C.A.EMAIL.UPDATE) &&
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-success me-2"
                                onClick={handleIsUpdateForm}>
                                <i className="bi bi-pencil-square" />
                            </button>
                        </OverlayTrigger>}

                    {myAbilities.has(C.A.EMAIL.DELETE) &&
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-danger me-2"
                                onClick={handleDeleteEmail}>
                                <i className="bi bi-trash" />
                            </button>
                        </OverlayTrigger>}

                </td>}
            </tr>
        </>
    )
}
export default Item